module.exports = function toPositive(number) {
  return number < 0 ? 0 : (+number || 0);
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/helper/toPositive.js
// module id = 718
// module chunks = 0